@if (!hideMode) {
  <div class="flex align-item-center justify-content-between">
    <select [(ngModel)]="mode" class="form-select-sm" (change)="onChangeMode($event)" [style.opacity]="1">
      <option [value]="'simple'">Simple</option>
      <option [value]="'expression'">Expresion</option>
      <option [value]="'script'">Script</option>
    </select>
  </div>
}

@if(mode){
  <br />
}

<!--[optionsUrl]="inputOptionsUrl"
[filter]="inputOptionsFilter" -->
@if (mode === 'simple') {
  <app-field-text
    [label]="'Entrada'"
    [value]="value?.input"
    (valueChange)="onChangeInput($event)"
  />
}

@if (mode === 'expression') {
  <div class="row">
    <div class="col-12 col-md-12">
      <app-field-select
        [label]="'Entrada'"
        [optionsUrl]="inputOptionsUrl"
        [filter]="inputOptionsFilter"
        [value]="value?.input"
        (valueChange)="onChangeInput($event)"
      />
    </div>
    <div class="col-12 col-md-12">
      <app-field-select
        [label]="'Operacion'"
        [value]="value?.operation"
        [options]="operationOptions"
        (valueChange)="onChangeOperation($event)"
      />
    </div>
    <div class="col-12 col-md-12">
      <app-field-text
        [label]="'Valor'"
        [value]="value?.value"
        (valueChange)="onChangeValue($event)"
      />
    </div>
    <div class="col-6 col-md-3">

    </div>
  </div>
}

@if (mode === 'script') {
  <div class="script-content">
    <ngx-codemirror
      [(ngModel)]="value.input"
      [options]="options"
      (ngModelChange)="onChangeScriptTarget($event)"
    />
  </div>
}
